import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

export interface BulkGenerationRequest {
  year: number;
  from_month: number;
  to_month: number;
  include_inactive: boolean;
  test_run: boolean;
}

export interface BulkGenerationResponse {
  success: boolean;
  bulk_run_id: string;
  message: string;
}

export interface BulkGenerationProgress {
  run: {
    id: string;
    standort_id?: string;
    from_date: string;
    to_date: string;
    total_candidates: number;
    created_count: number;
    skipped_existing_count: number;
    errors_count: number;
    started_at: string;
    finished_at?: string;
  };
  items: Array<{
    id: string;
    run_id: string;
    projektaufgabe_id?: string;
    datum: string;
    action: string;
    message: string;
    created_at: string;
  }>;
}

@Injectable({
  providedIn: 'root'
})
export class BulkKontrollterminGenerationService {
  private apiUrl = environment.apiUrl;

  constructor(private http: HttpClient) { }

  /**
   * Generate kontrolltermine for all standorte
   */
  generateForAllStandorte(request: BulkGenerationRequest): Observable<BulkGenerationResponse> {
    return this.http.post<BulkGenerationResponse>(`${this.apiUrl}/generator/kontrolltermine/bulk`, request);
  }

  /**
   * Get bulk generation run details
   */
  getBulkRun(bulkRunId: string): Observable<{success: boolean; data: BulkGenerationProgress}> {
    return this.http.get<{success: boolean; data: BulkGenerationProgress}>(`${this.apiUrl}/generator/kontrolltermine/bulk/${bulkRunId}`);
  }
}
